import { AgricultureMapConstants, LAYER_TYPES, LOCATIONS_ZOOM_RANGE } from "src/app/main/constants/dims-map-constants"

export const LOCATION_HIE: any = ['COUNTRY', 'STATE', 'DISTRICT', 'BLOCK']
export const RF_ACTUAL_LAYER_LIST: any = {
    [AgricultureMapConstants.LOCATIONS.INDIA]: {
        'State Boundary': {
            source: 'INDIA',
            displayName: 'State',
            name: 'State Boundary',
            visible: true,
            // hasLegend: true,
            view: AgricultureMapConstants.VIEWS.ADMIN,
            dashboardView: AgricultureMapConstants.LOCATIONS.INDIA,
            layerptions_show_on_selector: false,
            layeroptions_name: 'HEATWAVE:ALL_INDIA_STATE',
            layer_name: 'State Boundary',
            layeroptions_pane: 'depth',
            // layeroptions_min_zoom: LOCATIONS_ZOOM_RANGE[AgricultureMapConstants.LOCATIONS.DISTRICT].MIN,
            layeroptions_min_zoom: LOCATIONS_ZOOM_RANGE[AgricultureMapConstants.LOCATIONS.STATE].MIN - 1,
            layeroptions_max_zoom: LOCATIONS_ZOOM_RANGE[AgricultureMapConstants.LOCATIONS.STATE].MAX,
            group: 'boundaries',
            group_type: 'radio-deselect',
            layerServiceType: LAYER_TYPES.VECTOR_LAYER,
            type: LAYER_TYPES.VECTOR_LAYER,
            cql_filter_value: null,
            cql_filter: null,
            layerFrom: AgricultureMapConstants.SOURCES.GEOSERVER,
            environment_server_url: 'COMMON_GEOSERVER_URL',
            // layeroptions_styles: 'HEATWAVE:INDIA_DISTRICT_NAMES',
            crs: 'EPSG4326',
            hasLables: true,
            applycql_filter: true,
            legendName: 'PAST_DATE',
            layeroptions_protocol: 'WFS'
        },
        'State Boundaries': {
            source: 'INDIA',
            displayName: 'State Boundaries',
            name: 'State Boundaries',
            visible: true,
            view: AgricultureMapConstants.VIEWS.ADMIN,
            dashboardView: AgricultureMapConstants.LOCATIONS.INDIA,
            layerptions_show_on_selector: false,
            layeroptions_name: 'HEATWAVE:ALL_INDIA_STATE',
            layer_name: 'State Boundaries',
            layeroptions_pane: 'depth',
            layeroptions_min_zoom: LOCATIONS_ZOOM_RANGE[AgricultureMapConstants.LOCATIONS.VILLAGE].MIN,
            layeroptions_max_zoom: LOCATIONS_ZOOM_RANGE[AgricultureMapConstants.LOCATIONS.VILLAGE].MAX,
            group: 'boundaries',
            group_type: 'radio-deselect',
            layerServiceType: LAYER_TYPES.GEOJSON_LAYER,
            type: LAYER_TYPES.GEOJSON_LAYER,
            cql_filter_value: 'UUID',
            cql_filter: null,
            layerFrom: AgricultureMapConstants.SOURCES.GEOSERVER,
            onEachFeature: 'handleAdminPolygons',
            environment_server_url: 'COMMON_GEOSERVER_URL',
            layeroptions_protocol: 'WFS'
        },
        'District Boundaries': {
            source: 'INDIA',
            displayName: 'District Boundaries',
            name: 'District Boundaries',
            visible: true,
            view: AgricultureMapConstants.VIEWS.ADMIN,
            dashboardView: AgricultureMapConstants.LOCATIONS.INDIA,
            layerptions_show_on_selector: false,
            layeroptions_name: 'HEATWAVE:ALL_INDIA_DISTRICT',
            layer_name: 'District Boundaries',
            layeroptions_pane: 'max',
            layeroptions_min_zoom: LOCATIONS_ZOOM_RANGE[AgricultureMapConstants.LOCATIONS.DISTRICT].MIN,
            layeroptions_max_zoom: LOCATIONS_ZOOM_RANGE[AgricultureMapConstants.LOCATIONS.VILLAGE].MAX,
            group: 'boundaries',
            group_type: 'radio-deselect',
            layerServiceType: LAYER_TYPES.GEOJSON_LAYER,
            type: LAYER_TYPES.GEOJSON_LAYER,
            cql_filter_value: 'UUID',
            cql_filter: null,
            layerFrom: AgricultureMapConstants.SOURCES.GEOSERVER,
            onEachFeature: 'handleAdminPolygons',
            environment_server_url: 'COMMON_GEOSERVER_URL',
            layeroptions_protocol: 'WFS'
        },
        'District Boundary': {
            source: 'INDIA',
            displayName: 'District',
            name: 'District Boundary',
            visible: true,
            // hasLegend: true,
            view: AgricultureMapConstants.VIEWS.ADMIN,
            dashboardView: AgricultureMapConstants.LOCATIONS.INDIA,
            layerptions_show_on_selector: false,
            layeroptions_name: 'HEATWAVE:ALL_INDIA_DISTRICT',
            layer_name: 'District Boundary',
            layeroptions_pane: 'district',
            // layeroptions_min_zoom: LOCATIONS_ZOOM_RANGE[AgricultureMapConstants.LOCATIONS.DISTRICT].MIN,
            layeroptions_min_zoom: LOCATIONS_ZOOM_RANGE[AgricultureMapConstants.LOCATIONS.STATE].MIN - 1,
            layeroptions_max_zoom: LOCATIONS_ZOOM_RANGE[AgricultureMapConstants.LOCATIONS.DISTRICT].MAX,
            group: 'boundaries',
            group_type: 'radio-deselect',
            layerServiceType: LAYER_TYPES.VECTOR_LAYER,
            type: LAYER_TYPES.VECTOR_LAYER,
            cql_filter_value: null,
            cql_filter: null,
            layerFrom: AgricultureMapConstants.SOURCES.GEOSERVER,
            environment_server_url: 'COMMON_GEOSERVER_URL',
            // layeroptions_styles: 'HEATWAVE:INDIA_DISTRICT_NAMES',
            crs: 'EPSG4326',
            hasLables: true,
            applycql_filter: true,
            legendName: 'PAST_DATE',
            layeroptions_protocol: 'WFS'
        },
        'Block Boundary': {
            source: 'INDIA',
            displayName: 'Block',
            name: 'Block Boundary',
            visible: true,
            view: AgricultureMapConstants.VIEWS.ADMIN,
            dashboardView: AgricultureMapConstants.LOCATIONS.INDIA,
            layerptions_show_on_selector: false,
            layeroptions_name: 'HEATWAVE:ALL_INDIA_BLOCKS',
            layer_name: 'Block Boundary',
            layeroptions_pane: 'state',
            // layeroptions_min_zoom: LOCATIONS_ZOOM_RANGE[AgricultureMapConstants.LOCATIONS.DISTRICT].MIN,
            layeroptions_min_zoom: LOCATIONS_ZOOM_RANGE[AgricultureMapConstants.LOCATIONS.STATE].MIN - 2,
            layeroptions_max_zoom: LOCATIONS_ZOOM_RANGE[AgricultureMapConstants.LOCATIONS.BLOCK].MAX,
            group: 'boundaries',
            group_type: 'radio-deselect',
            layerServiceType: LAYER_TYPES.VECTOR_LAYER,
            type: LAYER_TYPES.VECTOR_LAYER,
            cql_filter_value: null,
            cql_filter: null,
            layerFrom: AgricultureMapConstants.SOURCES.GEOSERVER,
            environment_server_url: 'COMMON_GEOSERVER_URL',
            // layeroptions_styles: 'HEATWAVE:ALL_INDIA_BLOCK_NAMES',
            crs: 'EPSG4326',
            hasLables: true,
            applycql_filter: true,
            legendName: 'PAST_DATE',
            layeroptions_protocol: 'WFS'
        },
        'State Boundary Labels': {
            source: 'INDIA',
            displayName: 'State',
            name: 'State Boundary Labels',
            visible: true,
            view: AgricultureMapConstants.VIEWS.ADMIN,
            dashboardView: AgricultureMapConstants.LOCATIONS.INDIA,
            layerptions_show_on_selector: false,
            layeroptions_name: 'HEATWAVE:ALL_INDIA_STATE',
            layer_name: 'State Boundary',
            layeroptions_pane: 'depth',
            layeroptions_min_zoom: LOCATIONS_ZOOM_RANGE[AgricultureMapConstants.LOCATIONS.STATE].MIN - 1,
            layeroptions_max_zoom: LOCATIONS_ZOOM_RANGE[AgricultureMapConstants.LOCATIONS.STATE].MAX,
            group: 'boundaries',
            group_type: 'radio-deselect',
            layerServiceType: LAYER_TYPES.WMS_LAYER,
            type: LAYER_TYPES.WMS_LAYER,
            cql_filter: null,
            layerFrom: AgricultureMapConstants.SOURCES.GEOSERVER,
            environment_server_url: 'COMMON_GEOSERVER_URL',
            layeroptions_styles: 'HEATWAVE:INDIA_STATE_NAMES',
            crs: 'EPSG4326',
        },
        'District Boundary Labels': {
            source: 'INDIA',
            displayName: 'District Boundary Labels',
            name: 'District Boundary Labels',
            visible: true,
            view: AgricultureMapConstants.VIEWS.ADMIN,
            dashboardView: AgricultureMapConstants.LOCATIONS.INDIA,
            layerptions_show_on_selector: false,
            layeroptions_name: 'HEATWAVE:ALL_INDIA_DISTRICT',
            layer_name: 'District Boundary Labels',
            layeroptions_pane: 'names',
            layeroptions_min_zoom: LOCATIONS_ZOOM_RANGE[AgricultureMapConstants.LOCATIONS.STATE].MIN - 2,
            layeroptions_max_zoom: LOCATIONS_ZOOM_RANGE[AgricultureMapConstants.LOCATIONS.STATE].MAX,
            group: 'Labels',
            group_type: 'radio-deselect',
            layerServiceType: LAYER_TYPES.WMS_LAYER,
            type: LAYER_TYPES.WMS_LAYER,
            cql_filter_value: 'State_UUID',
            cql_filter: null,
            layerFrom: AgricultureMapConstants.SOURCES.GEOSERVER,
            environment_server_url: 'COMMON_GEOSERVER_URL',
            layeroptions_styles: 'HEATWAVE:INDIA_DISTRICT_NAMES',
            crs: 'EPSG4326',
        },
        'Block Boundary Labels': {
            source: 'INDIA',
            displayName: 'Block Boundary Labels',
            name: 'Block Boundary Labels',
            visible: true,
            view: AgricultureMapConstants.VIEWS.ADMIN,
            dashboardView: AgricultureMapConstants.LOCATIONS.INDIA,
            layerptions_show_on_selector: false,
            layeroptions_name: 'HEATWAVE:ALL_INDIA_BLOCKS',
            layer_name: 'Block Boundary Labels',
            layeroptions_pane: 'names',
            layeroptions_min_zoom: LOCATIONS_ZOOM_RANGE[AgricultureMapConstants.LOCATIONS.STATE].MIN - 2,
            layeroptions_max_zoom: LOCATIONS_ZOOM_RANGE[AgricultureMapConstants.LOCATIONS.BLOCK].MAX,
            group: 'Labels',
            group_type: 'radio-deselect',
            layerServiceType: LAYER_TYPES.WMS_LAYER,
            type: LAYER_TYPES.WMS_LAYER,
            cql_filter_value: 'Dist_UUID',
            cql_filter: null,
            layerFrom: AgricultureMapConstants.SOURCES.GEOSERVER,
            environment_server_url: 'COMMON_GEOSERVER_URL',
            layeroptions_styles: 'HEATWAVE:ALL_INDIA_BLOCK_NAMES',
            crs: 'EPSG4326',
        },
        'District Layer': {
            source: 'INDIA',
            displayName: 'District',
            name: 'District Layer',
            visible: true,
            view: AgricultureMapConstants.VIEWS.ADMIN,
            dashboardView: AgricultureMapConstants.LOCATIONS.INDIA,
            layerptions_show_on_selector: false,
            layeroptions_name: 'HEATWAVE:ALL_INDIA_DISTRICT',
            layer_name: 'District Layer',
            layeroptions_pane: 'district',
            layeroptions_min_zoom: LOCATIONS_ZOOM_RANGE[AgricultureMapConstants.LOCATIONS.DISTRICT].MIN + 1,
            layeroptions_max_zoom: LOCATIONS_ZOOM_RANGE[AgricultureMapConstants.LOCATIONS.DISTRICT].MAX,
            group: 'boundaries',
            group_type: 'radio-deselect',
            layerServiceType: LAYER_TYPES.WMS_LAYER,
            type: LAYER_TYPES.WMS_LAYER,
            cql_filter: null,
            layerFrom: AgricultureMapConstants.SOURCES.GEOSERVER,
            environment_server_url: 'COMMON_GEOSERVER_URL',
            layeroptions_styles: 'HEATWAVE:INDIA_DISTRICT_NAMES',
            crs: 'EPSG4326',
        },
        'Block Layer': {
            source: 'INDIA',
            displayName: 'Block',
            name: 'Block Layer',
            visible: true,
            view: AgricultureMapConstants.VIEWS.ADMIN,
            dashboardView: AgricultureMapConstants.LOCATIONS.INDIA,
            layerptions_show_on_selector: false,
            layeroptions_name: 'HEATWAVE:ALL_INDIA_BLOCKS',
            layer_name: 'Block Layer',
            layeroptions_pane: 'state',
            layeroptions_min_zoom: LOCATIONS_ZOOM_RANGE[AgricultureMapConstants.LOCATIONS.PANCHAYAT].MIN - 2,
            layeroptions_max_zoom: LOCATIONS_ZOOM_RANGE[AgricultureMapConstants.LOCATIONS.PANCHAYAT].MAX,
            group: 'boundaries',
            group_type: 'radio-deselect',
            layerServiceType: LAYER_TYPES.WMS_LAYER,
            type: LAYER_TYPES.WMS_LAYER,
            cql_filter: null,
            layerFrom: AgricultureMapConstants.SOURCES.GEOSERVER,
            environment_server_url: 'COMMON_GEOSERVER_URL',
            layeroptions_styles: 'HEATWAVE:ALL_INDIA_BLOCK_NAMES',
            crs: 'EPSG4326',
        }
    }
}

export const RainfallActualMapConstants: any = {

    HeatMapUrl: 'rf/heatmap',

    HeatMapOptions: {
        type: 'Time',
        time: '24',
        clip: true,
        view: 'Admin',
        serviceType: 'HeatMap'
    },

    HeatMapImageBound: { "southWest": { "latitude": 6.762376, "longitude": 68.144846 }, "northEast": { "latitude": 37.07827, "longitude": 97.46739 } },

    RFACTUAL_LEGEND: {
        'CURRENT_DATE': {
            colorValues: [
                {
                    backgroundColor: '#DEDEDD',
                    textColor: '#000000',
                    text: '0.0-0.1'
                },
                {
                    backgroundColor: '#D1FCC4',
                    textColor: '#000000',
                    text: '0.2-2.5'
                },
                {
                    backgroundColor: '#97E994',
                    textColor: '#000000',
                    text: '2.6-15.5'
                },
                {
                    backgroundColor: '#048500',
                    textColor: '#FFFFFF',
                    text: '15.6-64.5'
                },
                {
                    backgroundColor: '#FDA3A5',
                    textColor: '#FFFFFF',
                    text: '64.6-115.6'
                },
                {
                    backgroundColor: '#FEBF02',
                    textColor: '#FFFFFF',
                    text: '115.7-204.5'
                },
                {
                    backgroundColor: '#6BC8D1',
                    textColor: '#FFFFFF',
                    text: '204.6-250.1'
                },
                {
                    backgroundColor: '#AFA5FC',
                    textColor: '#FFFFFF',
                    text: '250.2-300.1'
                },
                {
                    backgroundColor: '#9C34C7',
                    textColor: '#FFFFFF',
                    text: '>300.1'
                }
            ],
            Units: 'Rainfall in mm',
        },
        'PAST_DATE': {
            colorValues: [
                {
                    backgroundColor: '#DEDEDD',
                    textColor: '#000000',
                    text: '0-100'
                },
                {
                    backgroundColor: '#D1FCC4',
                    textColor: '#000000',
                    text: '101-250'
                },
                {
                    backgroundColor: '#97E994',
                    textColor: '#000000',
                    text: '251-500'
                },
                {
                    backgroundColor: '#048500',
                    textColor: '#FFFFFF',
                    text: '501-750'
                },
                {
                    backgroundColor: '#FDA3A5',
                    textColor: '#FFFFFF',
                    text: '751-1000'
                },
                {
                    backgroundColor: '#FEBF02',
                    textColor: '#FFFFFF',
                    text: '1001-2000'
                },
                {
                    backgroundColor: '#6BC8D1',
                    textColor: '#FFFFFF',
                    text: '2001-3000'
                },
                {
                    backgroundColor: '#AFA5FC',
                    textColor: '#FFFFFF',
                    text: '3001-4500'
                },
                {
                    backgroundColor: '#9C34C7',
                    textColor: '#000000',
                    text: '4501-6000'
                }
            ],
            Units: 'Rainfall in mm',
        },
    }
}
